import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IGetRestaurantAvailableHoursResponseApi } from "@interfaces/IGetRestaurantAvailableHoursResponseApi.ts"
import { IGetRestaurantAvailableHoursResponseCli } from "@interfaces/IGetRestaurantAvailableHoursResponseCli.ts"

export const GetRestaurantAvailableHoursAdapter = (
	response: IApiResponse<IGetRestaurantAvailableHoursResponseApi>
): IGetRestaurantAvailableHoursResponseCli | null => {
	const data = response?.data

	if (
		!data ||
		!data.opening_time ||
		!data.closing_time ||
		!data.available_time_blocks
	) {
		return null
	}

	const [openingTimeHours, openingTimeMinutes] = data.opening_time
		.split(":")
		.map((item) => parseInt(item, 10))

	const [closingTimeHours, closingTimeMinutes] = data.closing_time
		.split(":")
		.map((item) => parseInt(item, 10))

	const availableTimeBlocks = data.available_time_blocks.map<
		IGetRestaurantAvailableHoursResponseCli["availableTimeBlocks"][0]
	>((block) => {
		const [startTime, endTime] = block.split("-")

		const [startHours, startMinutes] = startTime
			.split(":")
			.map((item) => parseInt(item, 10))

		const [endHours, endMinutes] = endTime
			.split(":")
			.map((item) => parseInt(item, 10))

		return {
			start: { hours: startHours, minutes: startMinutes },
			end: { hours: endHours, minutes: endMinutes },
		}
	})

	return {
		openingTime: {
			hours: openingTimeHours,
			minutes: openingTimeMinutes,
		},
		closingTime: {
			hours: closingTimeHours,
			minutes: closingTimeMinutes,
		},
		availableTimeBlocks,
	}
}
